import { render } from "./clients-list.vue?vue&type=template&id=9de88a84"
import script from "./clients-list.vue?vue&type=script&lang=js"
export * from "./clients-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__